// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"881e325a","240":"e2804498"}[chunkId] + ".chunk.css";
};